(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-form"] && !Shopify.designMode) return;
  try {
    
/* The form posts to Formspark as a normal form submission. This loads
   the hCaptcha script, which renders the widget into .h-captcha, renders
   the widget itself when the script is already there (the theme editor
   reloading the section), and stops a submit with an unsolved hCaptcha,
   which Formspark would answer with its own error page. */
class B2bForm extends HTMLElement {
  connectedCallback() {
    var form = this.querySelector('[data-b2b-form]');
    if (!form) return;
    var captcha = form.querySelector('.h-captcha');
    var captchaError = form.querySelector('[data-captcha-error]');
    var submit = form.querySelector('button[type="submit"]');

    if (captcha && !captcha.hasChildNodes()) {
      if (window.hcaptcha) {
        window.hcaptcha.render(captcha, { sitekey: captcha.dataset.sitekey });
      } else if (!document.querySelector('script[data-hcaptcha]')) {
        var script = document.createElement('script');
        script.src = this.dataset.captchaScript;
        script.async = true;
        script.dataset.hcaptcha = '';
        document.head.appendChild(script);
      }
    }

    form.addEventListener('submit', function (event) {
      // hCaptcha adds this field when it renders; if its script was
      // blocked there is nothing to check and Formspark decides.
      var response = form.querySelector('[name="h-captcha-response"]');
      if (response && !response.value) {
        event.preventDefault();
        if (captchaError) captchaError.hidden = false;
        return;
      }
      if (captchaError) captchaError.hidden = true;
      if (submit) submit.disabled = true;
    });
  }
}

if (!customElements.get('b2b-form')) {
  customElements.define('b2b-form', B2bForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-hero"] && !Shopify.designMode) return;
  try {
    
  // Readers with reduced motion turned on get the hero video paused
  // instead of autoplaying; the controls (or a tap) still play it.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.blog-hero__video[data-autoplay]').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-product"] && !Shopify.designMode) return;
  try {
    
  if (!window.__blogProductCartHandlerAttached) {
    window.__blogProductCartHandlerAttached = true;

    document.addEventListener('submit', async function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('blog-product__form')) return;

      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      try {
        const addRes = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!addRes.ok) throw new Error('cart/add status ' + addRes.status);
        const cart = await (await fetch('/cart.js')).json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } catch (err) {
        console.error('Blog product add-to-cart failed:', err);
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-related"] && !Shopify.designMode) return;
  try {
    
  class BlogRelated extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-related-track]');
      this.bar = this.querySelector('[data-related-progress]');
      if (!this.track) return;

      this.onScroll = () => this.updateProgress();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.setupDrag();
      // Start from the first card regardless of any restored scroll position.
      this.track.scrollLeft = 0;
      this.updateProgress();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onScroll);
    }

    updateProgress() {
      if (!this.bar) return;
      const { scrollWidth, clientWidth, scrollLeft } = this.track;
      const maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        this.bar.style.width = '100%';
        this.bar.style.transform = 'translateX(0)';
        return;
      }
      const ratio = clientWidth / scrollWidth;
      const progress = scrollLeft / maxScroll;
      const barWidth = Math.max(ratio * 100, 8);
      this.bar.style.width = barWidth + '%';
      this.bar.style.transform = 'translateX(' + (progress * (100 - barWidth) / barWidth) * 100 + '%)';
    }

    setupDrag() {
      const track = this.track;
      let startX = 0;
      let startScroll = 0;
      let dragging = false;
      let moved = false;

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      window.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          track.classList.add('is-dragging');
        }
        if (moved) track.scrollLeft = startScroll - dx;
      });

      const stop = () => {
        if (!dragging) return;
        dragging = false;
        // Keep pointer-events blocked for one tick so the mouseup doesn't
        // register as a click on a card after dragging.
        setTimeout(() => track.classList.remove('is-dragging'), 0);
      };
      window.addEventListener('pointerup', stop);
      window.addEventListener('pointercancel', stop);
    }
  }

  if (!customElements.get('blog-related')) {
    customElements.define('blog-related', BlogRelated);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-video"] && !Shopify.designMode) return;
  try {
    
/* Cover image facade for YouTube / Vimeo: the player iframe is only
   created when the reader presses play, then starts right away. */
class BlogVideo extends HTMLElement {
  connectedCallback() {
    var autoplayVideo = this.querySelector('video[data-autoplay]');
    if (autoplayVideo && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      autoplayVideo.removeAttribute('autoplay');
      autoplayVideo.pause();
    }

    var cover = this.querySelector('[data-embed-src]');
    if (!cover) return;
    cover.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.className = 'blog-video__embed';
      iframe.src = cover.dataset.embedSrc + '&autoplay=1';
      iframe.title = cover.dataset.title || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      cover.replaceWith(iframe);
    });
  }
}

if (!customElements.get('blog-video')) {
  customElements.define('blog-video', BlogVideo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Asks before a line is removed: through the "Remove" link, the stepper
  // or a quantity typed as zero. Resolves true straight away without the
  // confirm box.
  function confirmCartPageRemove() {
    var box = document.querySelector('.cart-page [data-cart-remove-confirm]');
    if (!box || typeof window.confirmCartRemove !== 'function') return Promise.resolve(true);
    return window.confirmCartRemove(box);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    var input = btn.closest('[data-cart-row]').querySelector('input[name="updates[]"]');
    var form = btn.closest('form');
    var next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.dataset.cartQty, 10));
    if (next > 0) {
      input.value = next;
      form.submit();
      return;
    }
    confirmCartPageRemove().then(function (confirmed) {
      if (!confirmed) return;
      input.value = 0;
      form.submit();
    });
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.cart-page__qty input')) return;
    var input = e.target;
    var form = input.closest('form');
    if (parseInt(input.value || '0', 10) > 0) {
      form.submit();
      return;
    }
    confirmCartPageRemove().then(function (confirmed) {
      if (confirmed) {
        form.submit();
        return;
      }
      // Back to the quantity the page was rendered with.
      input.value = input.defaultValue || 1;
    });
  });

  // "Remove" is a plain link to the change URL; ask first, then follow it.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cart-page__remove');
    if (!link) return;
    e.preventDefault();
    confirmCartPageRemove().then(function (confirmed) {
      if (confirmed) window.location.href = link.href;
    });
  });

  // Free-shipping reward: whenever the cart page loads with free shipping
  // reached, the bar fills from empty to the end and the check scales in.
  (function () {
    var run = function () {
      var bar = document.querySelector('[data-cart-page-shipping]');
      if (!bar || !bar.classList.contains('is-unlocked')) return;
      bar.style.setProperty('--shipping-from', '0%');
      bar.classList.add('is-celebrating');
      setTimeout(function () { bar.classList.remove('is-celebrating'); }, 1200);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  // Recommended products in the empty state (shop metafield): quantity
  // stepper + add, then reload so the server-rendered cart shows the line.
  document.addEventListener('click', async function (e) {
    if (!e.target.closest('[data-cart-empty-recs]')) return;

    var qtyBtn = e.target.closest('[data-upsell-qty]');
    if (qtyBtn) {
      var value = qtyBtn.closest('.cart-page__qty').querySelector('[data-upsell-qty-value]');
      value.textContent = Math.max(1, (parseInt(value.textContent, 10) || 1) + parseInt(qtyBtn.dataset.upsellQty, 10));
      return;
    }

    var btn = e.target.closest('[data-cart-page-upsell-add]');
    if (!btn) return;
    var qtyEl = btn.closest('.cart-page__upsell-item').querySelector('[data-upsell-qty-value]');
    var quantity = qtyEl ? Math.max(1, parseInt(qtyEl.textContent, 10) || 1) : 1;
    btn.disabled = true;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(btn.dataset.cartPageUpsellAdd), quantity: quantity }),
      });
      if (!res.ok) {
        var error = await res.json().catch(function () { return null; });
        if (error && error.description) alert(error.description);
        btn.disabled = false;
        return;
      }
      location.reload();
    } catch (err) {
      console.error('Failed to add recommended product:', err);
      btn.disabled = false;
    }
  });

  // "Others also bought" carousel: same source and rules as the mini-cart
  // drawer — complementary recommendations first, related as fallback,
  // products already in the cart skipped — but up to 8 products. Each card
  // has a quantity stepper; adding reloads the page so the server-rendered
  // lines and totals update.
  (function () {
    var start = function () {
      var wrap = document.querySelector('[data-cart-page-upsell]');
      if (!wrap) return;
      var list = wrap.querySelector('[data-cart-page-upsell-list]');
      var ids = Array.prototype.map.call(document.querySelectorAll('[data-cart-row][data-product-id]'), function (row) {
        return String(row.dataset.productId);
      }).filter(function (id, i, all) { return id && all.indexOf(id) === i; });
      if (!ids.length) return;

      var LIMIT = 8;
      var inCart = new Set(ids);
      var seen = new Set();
      var recs = [];

      var escapeHtml = function (str) {
        var el = document.createElement('span');
        el.textContent = str == null ? '' : String(str);
        return el.innerHTML;
      };
      // The header's mini-cart formats with the shop's money format; fall
      // back to a plain number if it is not on the page.
      var formatMoney = function (cents) {
        var miniCart = document.querySelector('mini-cart');
        if (miniCart && typeof miniCart.formatMoney === 'function') return miniCart.formatMoney(cents);
        return (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
      };
      var imageUrl = function (src, width) {
        try {
          var url = new URL(src, location.origin);
          url.searchParams.set('width', width);
          return url.toString();
        } catch (err) {
          return src;
        }
      };

      var load = async function () {
        for (var intent of ['complementary', 'related']) {
          for (var id of ids) {
            if (recs.length >= LIMIT) break;
            try {
              var res = await fetch('/recommendations/products.json?product_id=' + id + '&limit=10&intent=' + intent);
              if (!res.ok) continue;
              ((await res.json()).products || []).forEach(function (p) {
                if (recs.length >= LIMIT || inCart.has(String(p.id)) || seen.has(p.id)) return;
                seen.add(p.id);
                recs.push(p);
              });
            } catch (err) {
              console.error('Failed to fetch recommendations:', err);
            }
          }
          if (recs.length >= LIMIT) break;
        }
        if (!recs.length) return;

        var tAdd = escapeHtml(wrap.dataset.tAdd);
        var tAddLabel = escapeHtml(wrap.dataset.tAddLabel);
        var tDecrease = escapeHtml(wrap.dataset.tDecrease);
        var tIncrease = escapeHtml(wrap.dataset.tIncrease);
        list.innerHTML = recs.map(function (p) {
          var variants = p.variants || [];
          var variant = variants.find(function (v) { return v.available; }) || variants[0];
          var price = variant ? variant.price : p.price;
          var compareAt = variant && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
          var url = escapeHtml(p.url);
          var buy = variant && variant.available
            ? '<div class="cart-page__upsell-buy">'
              + '<div class="cart-page__qty">'
              + '<button type="button" data-upsell-qty="-1" aria-label="' + tDecrease + '">&minus;</button>'
              + '<span class="cart-page__upsell-qty-value" data-upsell-qty-value>1</span>'
              + '<button type="button" data-upsell-qty="1" aria-label="' + tIncrease + '">+</button>'
              + '</div>'
              + '<button type="button" class="cart-page__upsell-add" data-cart-page-upsell-add="' + variant.id + '" aria-label="' + tAddLabel + ': ' + escapeHtml(p.title) + '">' + tAdd + '</button>'
              + '</div>'
            : '';
          return '<div class="cart-page__upsell-item">'
            + '<a href="' + url + '">' + (p.featured_image ? '<img src="' + escapeHtml(imageUrl(p.featured_image, 400)) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="200" height="200">' : '') + '</a>'
            + '<div class="cart-page__upsell-info">'
            + '<a href="' + url + '" class="cart-page__upsell-name">' + escapeHtml(p.title) + '</a>'
            + '<span class="cart-page__upsell-price">' + formatMoney(price) + (compareAt ? '<s>' + formatMoney(compareAt) + '</s>' : '') + '</span>'
            + '</div>'
            + buy
            + '</div>';
        }).join('');
        wrap.hidden = false;
        syncArrows();
      };

      // Arrows (desktop) page by one card width; hidden when everything fits.
      var prev = wrap.querySelector('[data-cart-page-upsell-prev]');
      var next = wrap.querySelector('[data-cart-page-upsell-next]');
      var nav = prev && prev.parentElement;
      var step = function () {
        var card = list.querySelector('.cart-page__upsell-item');
        var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : list.clientWidth;
      };
      var progress = wrap.querySelector('[data-cart-page-upsell-progress]');
      var bar = wrap.querySelector('[data-cart-page-upsell-progress-bar]');
      var syncArrows = function () {
        var max = list.scrollWidth - list.clientWidth;
        if (nav) {
          nav.hidden = max <= 1;
          prev.disabled = list.scrollLeft <= 1;
          next.disabled = list.scrollLeft >= max - 1;
        }
        if (progress && bar) {
          progress.hidden = max <= 1;
          if (max > 1) {
            var visible = list.clientWidth / list.scrollWidth;
            bar.style.width = Math.max(visible * 100, 10) + '%';
            bar.style.transform = 'translateX(' + (list.scrollLeft / max) * (100 / visible - 100) + '%)';
          }
        }
      };

      // Mouse/pen drag, the same as the product carousels: drag past a
      // small threshold to scroll, snap to the nearest card on release,
      // and swallow the click that ends a drag. Touch keeps native swipe.
      var DRAG_THRESHOLD = 5;
      var drag = { down: false, dragging: false, startX: 0, startScroll: 0, moved: 0 };
      list.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        drag.down = true;
        drag.dragging = false;
        drag.moved = 0;
        drag.startX = e.clientX;
        drag.startScroll = list.scrollLeft;
      });
      list.addEventListener('pointermove', function (e) {
        if (!drag.down) return;
        var dx = e.clientX - drag.startX;
        drag.moved = Math.max(drag.moved, Math.abs(dx));
        if (!drag.dragging && drag.moved > DRAG_THRESHOLD) {
          drag.dragging = true;
          if (!list.hasPointerCapture(e.pointerId)) list.setPointerCapture(e.pointerId);
          list.classList.add('is-dragging');
        }
        if (drag.dragging) {
          e.preventDefault();
          list.scrollLeft = drag.startScroll - dx;
        }
      });
      var snapToNearest = function () {
        var listLeft = list.getBoundingClientRect().left;
        var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
        var best = list.scrollLeft;
        var bestDist = Infinity;
        Array.prototype.forEach.call(list.children, function (card) {
          var target = Math.max(0, Math.min(maxScroll, list.scrollLeft + card.getBoundingClientRect().left - listLeft));
          var dist = Math.abs(target - list.scrollLeft);
          if (dist < bestDist) {
            bestDist = dist;
            best = target;
          }
        });
        list.scrollTo({ left: best, behavior: 'smooth' });
      };
      var endDrag = function (e) {
        if (!drag.down) return;
        drag.down = false;
        if (list.hasPointerCapture(e.pointerId)) list.releasePointerCapture(e.pointerId);
        if (drag.dragging) snapToNearest();
        requestAnimationFrame(function () {
          list.classList.remove('is-dragging');
          drag.dragging = false;
        });
      };
      list.addEventListener('pointerup', endDrag);
      list.addEventListener('pointercancel', endDrag);
      list.addEventListener('lostpointercapture', endDrag);
      list.addEventListener('click', function (e) {
        if (drag.moved > DRAG_THRESHOLD) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
      list.addEventListener('dragstart', function (e) { e.preventDefault(); });
      if (prev && next) {
        prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
      }
      list.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);

      list.addEventListener('click', async function (e) {
        var qtyBtn = e.target.closest('[data-upsell-qty]');
        if (qtyBtn) {
          var value = qtyBtn.closest('.cart-page__qty').querySelector('[data-upsell-qty-value]');
          value.textContent = Math.max(1, (parseInt(value.textContent, 10) || 1) + parseInt(qtyBtn.dataset.upsellQty, 10));
          return;
        }

        var btn = e.target.closest('[data-cart-page-upsell-add]');
        if (!btn) return;
        var qtyEl = btn.closest('.cart-page__upsell-item').querySelector('[data-upsell-qty-value]');
        var quantity = qtyEl ? Math.max(1, parseInt(qtyEl.textContent, 10) || 1) : 1;
        btn.disabled = true;
        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.cartPageUpsellAdd), quantity: quantity }] })
          });
          if (!res.ok) throw new Error('cart/add status ' + res.status);
          location.reload();
        } catch (err) {
          console.error('Failed to add recommendation:', err);
          btn.disabled = false;
        }
      });

      load();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
/* Keeps the production behaviour: the product-data fields become
   required only when "I have a Moccamaster" is ticked, the serial number
   is formatted as "1234 56789" and must hold 8-10 digits (same as the
   warranty registration form), and the optional
   image must stay under MAX_FILE_SIZE. The form itself posts to eee.do
   as a normal form submission. */
class ContactForm extends HTMLElement {
  connectedCallback() {
    var form = this.querySelector('[data-contact-form]');
    if (!form) return;
    var self = this;
    var toggle = form.querySelector('[data-has-moccamaster]');
    var panel = form.querySelector('[data-product-data]');
    var productInputs = form.querySelectorAll('[data-product-input]');
    var serial = form.querySelector('[data-serial]');
    var file = form.querySelector('input[type="file"]');
    var submit = form.querySelector('button[type="submit"]');

    if (toggle && panel) {
      var syncProductData = function () {
        var on = toggle.checked;
        panel.hidden = !on;
        productInputs.forEach(function (input) {
          if (on) input.setAttribute('required', '');
          else input.removeAttribute('required');
        });
      };
      toggle.addEventListener('change', syncProductData);
      syncProductData();
    }

    if (serial) {
      serial.addEventListener('input', function () {
        serial.value = serial.value
          .replace(/[^\dA-Z]/g, '')
          .replace(/(\d{4})/, '$1 ')
          .trim();
        var digits = serial.value.replace(/\D/g, '');
        serial.setCustomValidity(serial.value && (digits.length < 8 || digits.length > 10) ? self.dataset.serialError : '');
      });
    }

    if (file) {
      file.addEventListener('change', function () {
        var max = parseInt(file.dataset.maxSize, 10) || 0;
        var tooLarge = max && file.files[0] && file.files[0].size > max;
        file.setCustomValidity(tooLarge ? self.dataset.fileError : '');
        if (tooLarge) file.reportValidity();
      });
    }

    form.addEventListener('submit', function () {
      if (submit) submit.disabled = true;
    });
  }
}

if (!customElements.get('contact-form')) {
  customElements.define('contact-form', ContactForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
/* Client-side category filter and search. Every question is in the HTML
   (and in the FAQPage JSON-LD); this only shows and hides. The category
   can be preselected with the section setting or with ?kategori=<name>
   in the URL, so links can open the page filtered.

   Analytics: searches, category picks and opened questions are pushed
   to the GTM dataLayer (events faq_search, faq_category, faq_open), and
   the search term is mirrored into the URL as ?faqquery=<term> so it
   also shows up in page paths. Searches are reported once typing pauses. */
class FaqPanel extends HTMLElement {
  connectedCallback() {
    this.items = Array.prototype.slice.call(this.querySelectorAll('[data-faq-item]'));
    this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-faq-category]:not([data-faq-item])'));
    this.search = this.querySelector('[data-faq-search]');
    this.empty = this.querySelector('[data-faq-empty]');
    this.param = this.dataset.param || 'kategori';
    this.queryParam = this.dataset.queryParam || 'faqquery';
    this.category = '';
    this.query = '';
    this.lastTrackedQuery = '';
    this.visible = this.items.length;

    var self = this;
    var fromUrl = '';
    var queryFromUrl = '';
    try {
      var params = new URLSearchParams(window.location.search);
      fromUrl = params.get(this.param) || '';
      queryFromUrl = params.get(this.queryParam) || '';
    } catch (error) {
      fromUrl = '';
    }
    this.setCategory(fromUrl || this.dataset.defaultCategory || '', false);

    this.pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        self.setCategory(pill.dataset.faqCategory || '', true);
        self.track('faq_category', { faq_category: pill.dataset.faqCategory || 'all' });
      });
    });

    if (this.search) {
      if (queryFromUrl) {
        this.search.value = queryFromUrl;
        this.query = queryFromUrl.trim().toLowerCase();
        this.lastTrackedQuery = this.query;
        this.apply();
      }
      var timer = null;
      this.search.addEventListener('input', function () {
        self.query = self.search.value.trim().toLowerCase();
        self.apply();
        clearTimeout(timer);
        timer = setTimeout(function () { self.reportSearch(); }, 700);
      });
    }

    this.items.forEach(function (item) {
      item.faqText = self.searchTextOf(item);
      var summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function () { self.userToggled = item; });
      }
      item.addEventListener('toggle', function () {
        /* Only react to the reader's own clicks, not to items that start
           open or are opened from a deep link. */
        if (self.userToggled !== item) return;
        self.userToggled = null;
        self.syncHash(item);
        if (!item.open) return;
        var question = item.querySelector('.faq__question-text');
        self.track('faq_open', {
          faq_question: question ? question.textContent.trim() : '',
          faq_category: self.tagsOf(item).join(', ')
        });
      });

      var copy = item.querySelector('[data-faq-copy]');
      if (copy) {
        copy.addEventListener('click', function () { self.copyLink(item, copy); });
      }
    });

    this.openFromHash();
    window.addEventListener('hashchange', function () { self.openFromHash(); });
  }

  /* Opening a question puts #faq-<question> in the address bar so the
     URL can be shared; closing it removes the hash again. */
  syncHash(item) {
    if (!item.id || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    if (item.open) url.hash = item.id;
    else if (url.hash === '#' + item.id) url.hash = '';
    window.history.replaceState(null, '', url.toString());
  }

  openFromHash() {
    var hash = window.location.hash ? decodeURIComponent(window.location.hash.slice(1)) : '';
    if (!hash) return;
    var item = this.items.find(function (candidate) { return candidate.id === hash; });
    if (!item) return;
    if (this.category && this.tagsOf(item).map(this.slug).indexOf(this.category) === -1) {
      this.setCategory('', true);
    }
    if (this.search && this.query) {
      this.search.value = '';
      this.query = '';
      this.apply();
    }
    item.open = true;
    var self = this;
    window.setTimeout(function () { item.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
  }

  copyLink(item, button) {
    var url = new URL(window.location.href);
    url.hash = item.id;
    url.searchParams.delete(this.queryParam);
    var text = url.toString();
    var label = button.querySelector('[data-faq-copy-label]') || button;
    var original = label.textContent;
    var done = function () {
      label.textContent = button.dataset.copiedLabel || original;
      button.classList.add('is-copied');
      window.setTimeout(function () {
        label.textContent = original;
        button.classList.remove('is-copied');
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () { window.prompt('', text); });
    } else {
      window.prompt('', text);
    }
  }

  tagsOf(item) {
    return String(item.dataset.faqTags || '').split('|').filter(function (tag) { return tag; });
  }

  /* Question plus answer body; the tags line and copy button are left
     out so searching for "tagger" or "kopier" does not match everything. */
  searchTextOf(item) {
    var question = item.querySelector('.faq__question-text');
    var answer = item.querySelector('.faq__answer');
    var parts = [question ? question.textContent : ''];
    if (answer) {
      Array.prototype.forEach.call(answer.children, function (child) {
        if (!child.classList.contains('faq__footer')) parts.push(child.textContent);
      });
    }
    return parts.join(' ').replace(/\s+/g, ' ').toLowerCase();
  }

  track(name, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: name };
    for (var key in data) payload[key] = data[key];
    window.dataLayer.push(payload);
  }

  reportSearch() {
    var query = this.search ? this.search.value.trim() : '';
    this.setUrlParam(this.queryParam, query.length >= 2 ? query : '');
    if (query.length < 2 || query.toLowerCase() === this.lastTrackedQuery) return;
    this.lastTrackedQuery = query.toLowerCase();
    this.track('faq_search', {
      faq_query: query,
      faq_results: this.visible,
      faq_category: this.category || 'all'
    });
  }

  setUrlParam(name, value) {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      if (value) url.searchParams.set(name, value);
      else url.searchParams.delete(name);
      window.history.replaceState(null, '', url.toString());
    } catch (error) {
      /* ignore */
    }
  }

  slug(value) {
    return String(value || '').trim().toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');
  }

  setCategory(value, updateUrl) {
    var wanted = this.slug(value);
    var known = this.pills.some(function (pill) { return wanted && this.slug(pill.dataset.faqCategory) === wanted; }, this);
    this.category = known ? wanted : '';

    this.pills.forEach(function (pill) {
      var active = this.slug(pill.dataset.faqCategory) === this.category;
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    }, this);

    if (updateUrl) this.setUrlParam(this.param, this.category ? value : '');

    this.apply();
  }

  apply() {
    var visible = 0;
    this.items.forEach(function (item) {
      var slugs = this.tagsOf(item).map(this.slug);
      var categoryOk = !this.category || slugs.indexOf(this.category) !== -1;
      var text = item.faqText || item.textContent.toLowerCase();
      var queryOk = !this.query || text.indexOf(this.query) !== -1;
      var show = categoryOk && queryOk;
      item.hidden = !show;
      if (show) visible += 1;
    }, this);
    this.visible = visible;
    if (this.empty) this.empty.hidden = visible > 0;
  }
}

if (!customElements.get('faq-panel')) {
  customElements.define('faq-panel', FaqPanel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
document.querySelectorAll('[data-footer-menu]').forEach(function (menu) {
  var toggle = menu.querySelector('.footer__menu-toggle');
  if (!toggle) return;
  toggle.addEventListener('click', function () {
    if (!window.matchMedia('(max-width: 1269px)').matches) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    menu.classList.toggle('footer__menu--expanded');
  });
});

document.querySelectorAll('[data-country-selector]').forEach(function (selector) {
  document.addEventListener('click', function (event) {
    if (selector.hasAttribute('open') && !selector.contains(event.target)) {
      selector.removeAttribute('open');
    }
  });
  selector.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      selector.removeAttribute('open');
    }
  });
});

/* Newsletter signup: posts the form as multipart FormData (email, terms,
   language) to the market's link.<country>.moccamaster.com API, the same
   request the production popup makes. Native validation handles the
   required email and consent checkbox before submit fires. */
class NewsletterForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-newsletter-form]');
    if (!this.form) return;
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();
    var self = this;
    var form = this.form;
    var button = form.querySelector('button[type="submit"]');
    var message = form.querySelector('[data-newsletter-message]');
    var endpoint = this.dataset.endpoint || form.action;

    if (message) message.hidden = true;
    if (button) button.disabled = true;

    fetch(endpoint, { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) throw new Error('Newsletter signup failed with status ' + response.status);
        return response.json().catch(function () { return {}; });
      })
      .then(function () {
        self.showSuccess();
      })
      .catch(function (error) {
        console.error(error);
        if (message) {
          message.textContent = self.dataset.error;
          message.hidden = false;
        }
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }

  showSuccess() {
    var title = this.querySelector('[data-newsletter-title]');
    var description = this.querySelector('[data-newsletter-desc]');
    if (title && this.dataset.successTitle) title.textContent = this.dataset.successTitle;
    if (description && this.dataset.successText) description.textContent = this.dataset.successText;
    this.form.hidden = true;
    this.classList.add('footer__newsletter--success');
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontpage-builder"] && !Shopify.designMode) return;
  try {
    
class ProductSlider extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('.frontpage-product-slider__tab')];
    this.panels = [...this.querySelectorAll('.frontpage-product-slider__panel')];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tab));
    });

    this.panels.forEach((panel) => {
      const track = panel.querySelector('[data-slider-track]');
      const bar = panel.querySelector('[data-slider-progress]');
      const progress = panel.querySelector('.frontpage-product-slider__progress');
      if (!track) return;

      if (bar) {
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const overflowing = max > 1;
          if (progress) progress.style.display = overflowing ? '' : 'none';
          if (!overflowing) return;
          const ratio = track.scrollLeft / max;
          const visible = track.clientWidth / track.scrollWidth;
          bar.style.width = `${Math.max(visible * 100, 10)}%`;
          bar.style.transform = `translateX(${ratio * (100 / visible - 100)}%)`;
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        panel.__updateProgress = update;
        update();
      }

      this.enableDrag(track);
    });

    // Scroll-reveal: staggered entrance (title, tabs, cards) the first
    // time the slider enters the viewport.
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.classList.add('is-revealed');
          io.disconnect();
        }
      }, { rootMargin: '0px 0px -80px 0px' });
      io.observe(this);
    } else {
      this.classList.add('is-revealed');
    }
  }

  enableDrag(track) {
    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;
    let maxMoved = 0;
    const DRAG_THRESHOLD = 5;

    track.querySelectorAll('img').forEach((img) => img.setAttribute('draggable', 'false'));

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      isDown = true;
      isDragging = false;
      maxMoved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      maxMoved = Math.max(maxMoved, Math.abs(dx));
      if (!isDragging && maxMoved > DRAG_THRESHOLD) {
        isDragging = true;
        if (!track.hasPointerCapture(e.pointerId)) {
          track.setPointerCapture(e.pointerId);
        }
        track.classList.add('is-dragging');
      }
      if (isDragging) {
        e.preventDefault();
        track.scrollLeft = startScroll - dx;
      }
    });

    const snapToNearest = () => {
      const cards = [...track.children];
      if (cards.length === 0) return;
      const trackLeft = track.getBoundingClientRect().left;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const current = track.scrollLeft;

      let bestTarget = current;
      let bestDist = Infinity;

      for (const card of cards) {
        const delta = card.getBoundingClientRect().left - trackLeft;
        const raw = current + delta;
        const target = Math.max(0, Math.min(maxScroll, raw));
        const dist = Math.abs(target - current);
        if (dist < bestDist) {
          bestDist = dist;
          bestTarget = target;
        }
      }

      track.scrollTo({ left: bestTarget, behavior: 'smooth' });
    };

    const end = (e) => {
      if (!isDown) return;
      isDown = false;
      if (track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
      if (isDragging) snapToNearest();
      requestAnimationFrame(() => {
        track.classList.remove('is-dragging');
        isDragging = false;
      });
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('lostpointercapture', end);

    track.addEventListener('click', (e) => {
      if (maxMoved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    track.addEventListener('dragstart', (e) => e.preventDefault());
  }

  activate(index) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('aria-hidden');
        if (typeof panel.__updateProgress === 'function') {
          panel.__updateProgress();
        }
      } else {
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

if (!customElements.get('product-slider')) {
  customElements.define('product-slider', ProductSlider);
}

class CollectionSelector extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('[data-collection-track]');
    if (!track) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const designMode = window.Shopify && window.Shopify.designMode;
    const loop = !reducedMotion && !designMode && track.children.length >= 2;

    const bar = this.querySelector('[data-collection-progress]');
    const progress = this.querySelector('.frontpage-collection-selector__progress');

    if (loop) {
      if (progress) progress.style.display = 'none';
    } else if (bar) {
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const overflowing = max > 1;
        if (progress) progress.style.display = overflowing ? '' : 'none';
        if (!overflowing) return;
        const ratio = track.scrollLeft / max;
        const visible = track.clientWidth / track.scrollWidth;
        bar.style.width = `${Math.max(visible * 100, 10)}%`;
        bar.style.transform = `translateX(${ratio * (100 / visible - 100)}%)`;
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    this.enableDrag(track);
    if (loop) this.enableLoop(track);

    // Scroll-reveal for the header (title, then CTA) the first time the
    // block enters the viewport. The cards are deliberately left alone.
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.classList.add('is-revealed');
          io.disconnect();
        }
      }, { rootMargin: '0px 0px -80px 0px' });
      io.observe(this);
    } else {
      this.classList.add('is-revealed');
    }
  }

  /* Continuous marquee: the track drifts slowly and loops forever by
     moving cards from one end of the DOM to the other. The scroll
     position rests in a one-card window that sits a couple of viewports
     into the track, so there is runway to scroll or fling in either
     direction; once native scrolling comes to rest the cards are
     recycled and the position is pulled back into the window. Pauses
     while the user drags/scrolls, resumes shortly after. Skipped
     entirely for prefers-reduced-motion and in the theme editor. */
  enableLoop(track) {
    const SPEED = 25; // px per second
    const RESUME_DELAY = 2500;
    const SETTLE_DELAY = 150;

    track.classList.add('is-looping');

    const originals = [...track.children];
    const gap = () => parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = () => {
      const first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + gap() : 0;
    };

    // Runway on each side of the resting window. Native flings are not
    // interrupted (moving cards mid-fling would kill the momentum), so
    // this has to cover a generous gesture, also on narrow screens.
    const runwayBack = () => Math.max(track.clientWidth * 2, 1600);
    const runwayAhead = () => Math.max(track.clientWidth * 2.5, 2000);
    // Left edge of the resting window, a whole number of cards in.
    const home = () => {
      const s = step();
      return s > 0 ? Math.ceil(runwayBack() / s) * s : 0;
    };

    // Clone the card set until there is runway behind the window, a
    // viewport of cards in it and runway ahead of it.
    const ensureBuffer = () => {
      let guard = 0;
      while (
        step() > 0 &&
        track.scrollWidth < home() + track.clientWidth + runwayAhead() + step() &&
        guard < 20
      ) {
        originals.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('tabindex', '-1');
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          track.appendChild(clone);
        });
        guard++;
      }
    };
    ensureBuffer();
    window.addEventListener('resize', ensureBuffer);

    // Rotate the tail of the (cyclic) card list in front of the first
    // card and start scrolled past it: the first card is still what the
    // visitor sees first, but now there is something to scroll back to.
    let pos = 0;
    {
      const s = step();
      const n = s > 0 ? Math.round(home() / s) : 0;
      for (let i = 0; i < n; i++) {
        track.insertBefore(track.lastElementChild, track.firstElementChild);
      }
      pos = home();
      track.scrollLeft = pos;
    }

    let paused = false;
    let touching = false;
    let resumeTimer = null;
    let settleTimer = null;
    let inView = true;
    let last = null;

    const recycle = () => {
      let s = step();
      if (s <= 0) return;
      const h = home();
      let guard = 0;
      while (pos >= h + s && guard < 50) {
        track.appendChild(track.firstElementChild);
        pos -= s;
        track.scrollLeft = pos;
        if (track.__dragAdjust) track.__dragAdjust(-s);
        s = step();
        guard++;
      }
      guard = 0;
      while (pos < h && guard < 50) {
        const lastCard = track.lastElementChild;
        const w = lastCard.getBoundingClientRect().width + gap();
        track.insertBefore(lastCard, track.firstElementChild);
        pos += w;
        track.scrollLeft = pos;
        if (track.__dragAdjust) track.__dragAdjust(w);
        guard++;
      }
    };

    // Native scrolling (wheel, trackpad, touch flings, the snap after a
    // drag) is left alone until it has come to rest, then the cards are
    // recycled in one go. Never while a finger is still on the track.
    const settle = () => {
      settleTimer = null;
      if (touching || track.classList.contains('is-dragging')) return;
      pos = track.scrollLeft;
      recycle();
    };
    const scheduleSettle = () => {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, SETTLE_DELAY);
    };

    const pause = () => {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
    };
    const scheduleResume = () => {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        pos = track.scrollLeft;
        recycle();
        paused = false;
      }, RESUME_DELAY);
    };

    track.addEventListener('pointerdown', pause);
    track.addEventListener('pointerup', scheduleResume);
    track.addEventListener('pointercancel', scheduleResume);
    track.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'mouse') pause();
    });
    track.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      pos = track.scrollLeft;
      recycle();
      paused = false;
    });
    track.addEventListener('touchstart', () => {
      touching = true;
      pause();
    }, { passive: true });
    const touchDone = () => {
      touching = false;
      scheduleResume();
      scheduleSettle();
    };
    track.addEventListener('touchend', touchDone, { passive: true });
    track.addEventListener('touchcancel', touchDone, { passive: true });
    track.addEventListener('wheel', () => { pause(); scheduleResume(); }, { passive: true });

    track.addEventListener('scroll', () => {
      if (Math.abs(track.scrollLeft - pos) > 1.5) {
        pos = track.scrollLeft;
        if (track.classList.contains('is-dragging')) {
          // The drag drives the scroll itself, so cards can move mid-drag.
          recycle();
        } else {
          scheduleSettle();
          if (paused) scheduleResume();
        }
      }
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
      }).observe(this);
    }

    const tick = (t) => {
      if (last !== null && !paused && inView) {
        const dt = Math.min((t - last) / 1000, 0.1);
        pos += SPEED * dt;
        recycle();
        track.scrollLeft = pos;
      }
      last = t;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  enableDrag(track) {
    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;
    let maxMoved = 0;
    const DRAG_THRESHOLD = 5;

    // Lets the loop recycler shift the drag origin when it moves cards
    // between the ends of the track mid-drag.
    track.__dragAdjust = (delta) => {
      startScroll += delta;
    };

    track.querySelectorAll('img').forEach((img) => img.setAttribute('draggable', 'false'));

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      isDown = true;
      isDragging = false;
      maxMoved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      maxMoved = Math.max(maxMoved, Math.abs(dx));
      if (!isDragging && maxMoved > DRAG_THRESHOLD) {
        isDragging = true;
        if (!track.hasPointerCapture(e.pointerId)) {
          track.setPointerCapture(e.pointerId);
        }
        track.classList.add('is-dragging');
      }
      if (isDragging) {
        e.preventDefault();
        track.scrollLeft = startScroll - dx;
      }
    });

    const snapToNearest = () => {
      const cards = [...track.children];
      if (cards.length === 0) return;
      const trackLeft = track.getBoundingClientRect().left;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const current = track.scrollLeft;

      let bestTarget = current;
      let bestDist = Infinity;

      for (const card of cards) {
        const delta = card.getBoundingClientRect().left - trackLeft;
        const raw = current + delta;
        const target = Math.max(0, Math.min(maxScroll, raw));
        const dist = Math.abs(target - current);
        if (dist < bestDist) {
          bestDist = dist;
          bestTarget = target;
        }
      }

      track.scrollTo({ left: bestTarget, behavior: 'smooth' });
    };

    const end = (e) => {
      if (!isDown) return;
      isDown = false;
      if (track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
      if (isDragging) snapToNearest();
      requestAnimationFrame(() => {
        track.classList.remove('is-dragging');
        isDragging = false;
      });
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('lostpointercapture', end);

    track.addEventListener('click', (e) => {
      if (maxMoved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    track.addEventListener('dragstart', (e) => e.preventDefault());
  }
}

if (!customElements.get('collection-selector')) {
  customElements.define('collection-selector', CollectionSelector);
}

// Scroll-reveal for the plain frontpage blocks (split section and
// text-and-image): the fp-reveal tag arms the hidden state, so without
// JS the content simply stays visible.
document.querySelectorAll('.frontpage-split-section, .frontpage-text-and-image, .frontpage-fullscreen-image').forEach((el) => {
  el.classList.add('fp-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        el.classList.add('is-revealed');
        io.disconnect();
      }
    }, { rootMargin: '0px 0px -80px 0px' });
    io.observe(el);
  } else {
    el.classList.add('is-revealed');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infobar"]) return;
  try {
    
class InfoBar extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.infobar__slide')];
    this.ctas = [...this.querySelectorAll('.infobar__cta')];
    this.ctaByIndex = new Map(this.ctas.map((el) => [Number(el.dataset.index), el]));

    if (this.slides.length <= 1) return;

    this.current = 0;
    this.interval = setInterval(() => this.next(), 4000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  next() {
    const oldCta = this.ctaByIndex.get(this.current);
    this.slides[this.current].classList.remove('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'true');
    if (oldCta) {
      oldCta.classList.remove('is-active');
      oldCta.setAttribute('aria-hidden', 'true');
      oldCta.setAttribute('tabindex', '-1');
    }

    this.current = (this.current + 1) % this.slides.length;

    const newCta = this.ctaByIndex.get(this.current);
    this.slides[this.current].classList.add('is-active');
    this.slides[this.current].removeAttribute('aria-hidden');
    if (newCta) {
      newCta.classList.add('is-active');
      newCta.removeAttribute('aria-hidden');
      newCta.removeAttribute('tabindex');
    }
  }
}

if (!customElements.get('info-bar')) {
  customElements.define('info-bar', InfoBar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["link-panel"] && !Shopify.designMode) return;
  try {
    
/* Cards flagged "open chat" toggle the ImBox widget instead of navigating.
   Pushing to the _imbox queue is safe before the widget has loaded. */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-imbox-toggle]');
  if (!trigger) return;
  event.preventDefault();
  window._imbox = window._imbox || [];
  window._imbox.push(['toggle']);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('.product-carousel__tab')];
    this.panels = [...this.querySelectorAll('.product-carousel__panel')];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tab));
    });

    this.panels.forEach((panel) => {
      const track = panel.querySelector('[data-slider-track]');
      const bar = panel.querySelector('[data-slider-progress]');
      const progress = panel.querySelector('.product-carousel__progress');
      if (!track) return;

      if (bar) {
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const overflowing = max > 1;
          if (progress) progress.style.display = overflowing ? '' : 'none';
          if (!overflowing) return;
          const ratio = track.scrollLeft / max;
          const visible = track.clientWidth / track.scrollWidth;
          bar.style.width = `${Math.max(visible * 100, 10)}%`;
          bar.style.transform = `translateX(${ratio * (100 / visible - 100)}%)`;
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        panel.__updateProgress = update;
        update();
      }

      this.enableDrag(track);
    });
  }

  enableDrag(track) {
    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;
    let maxMoved = 0;
    const DRAG_THRESHOLD = 5;

    track.querySelectorAll('img').forEach((img) => img.setAttribute('draggable', 'false'));

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      isDown = true;
      isDragging = false;
      maxMoved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      maxMoved = Math.max(maxMoved, Math.abs(dx));
      if (!isDragging && maxMoved > DRAG_THRESHOLD) {
        isDragging = true;
        if (!track.hasPointerCapture(e.pointerId)) {
          track.setPointerCapture(e.pointerId);
        }
        track.classList.add('is-dragging');
      }
      if (isDragging) {
        e.preventDefault();
        track.scrollLeft = startScroll - dx;
      }
    });

    const snapToNearest = () => {
      const cards = [...track.children];
      if (cards.length === 0) return;
      const trackLeft = track.getBoundingClientRect().left;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const current = track.scrollLeft;

      let bestTarget = current;
      let bestDist = Infinity;

      for (const card of cards) {
        const delta = card.getBoundingClientRect().left - trackLeft;
        const raw = current + delta;
        const target = Math.max(0, Math.min(maxScroll, raw));
        const dist = Math.abs(target - current);
        if (dist < bestDist) {
          bestDist = dist;
          bestTarget = target;
        }
      }

      track.scrollTo({ left: bestTarget, behavior: 'smooth' });
    };

    const end = (e) => {
      if (!isDown) return;
      isDown = false;
      if (track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
      if (isDragging) snapToNearest();
      requestAnimationFrame(() => {
        track.classList.remove('is-dragging');
        isDragging = false;
      });
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('lostpointercapture', end);

    track.addEventListener('click', (e) => {
      if (maxMoved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    track.addEventListener('dragstart', (e) => e.preventDefault());
  }

  activate(index) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('aria-hidden');
        if (typeof panel.__updateProgress === 'function') {
          panel.__updateProgress();
        }
      } else {
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel);
}

if (!window.__productCarouselCartHandlerAttached) {
  window.__productCarouselCartHandlerAttached = true;

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains('product-carousel__form')) return;

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const addRes = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!addRes.ok) throw new Error('cart/add status ' + addRes.status);
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (err) {
      console.error('Product carousel add-to-cart failed:', err);
    } finally {
      if (btn) btn.disabled = false;
    }
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (slides.length < 2) return;

    let index = 0;
    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
      thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === index));

      const thumb = thumbs[index];
      const track = thumb && thumb.closest('.product__thumbs');
      if (thumb && track && track.scrollWidth > track.clientWidth) {
        const delta = thumb.getBoundingClientRect().left - track.getBoundingClientRect().left;
        const target = track.scrollLeft + delta - (track.clientWidth - thumb.offsetWidth) / 2;
        track.scrollTo({
          left: Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth)),
          behavior: 'smooth',
        });
      }
    };

    gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
    thumbs.forEach((thumb, n) => thumb.addEventListener('click', () => show(n)));

    // Line the arrows up with the thumbnail strip's outer edges.
    const main = gallery.querySelector('.product__main');
    const thumbsWrap = gallery.querySelector('.product__thumbs-wrap');
    const setArrowInset = () => {
      if (!main || !thumbsWrap) return;
      const inset = Math.max(0, (main.clientWidth - thumbsWrap.clientWidth) / 2);
      gallery.style.setProperty('--gallery-arrow-inset', inset + 'px');
    };
    setArrowInset();
    window.addEventListener('resize', setArrowInset);

    // Swipe the main image on touch screens. touch-action on .product__main
    // leaves vertical scrolling and pinch-zoom to the browser, so a
    // horizontal drag reaches us as one pointerdown/pointerup pair.
    if (main) {
      let startX = null;
      let startY = 0;
      main.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'touch' || !e.isPrimary) return;
        startX = e.clientX;
        startY = e.clientY;
      });
      main.addEventListener('pointerup', (e) => {
        if (startX === null || !e.isPrimary) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          show(index + (dx < 0 ? 1 : -1));
        }
      });
      main.addEventListener('pointercancel', () => {
        startX = null;
      });
    }
  });

  document.querySelectorAll('.product__thumbs').forEach(track => {
    let isDown = false;
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;
    let maxMoved = 0;
    const DRAG_THRESHOLD = 5;

    track.querySelectorAll('img').forEach(img => img.setAttribute('draggable', 'false'));

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      isDown = true;
      isDragging = false;
      maxMoved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      maxMoved = Math.max(maxMoved, Math.abs(dx));
      if (!isDragging && maxMoved > DRAG_THRESHOLD) {
        isDragging = true;
        if (!track.hasPointerCapture(e.pointerId)) {
          track.setPointerCapture(e.pointerId);
        }
        track.classList.add('is-dragging');
      }
      if (isDragging) {
        e.preventDefault();
        track.scrollLeft = startScroll - dx;
      }
    });

    const end = (e) => {
      if (!isDown) return;
      isDown = false;
      if (track.hasPointerCapture(e.pointerId)) {
        track.releasePointerCapture(e.pointerId);
      }
      requestAnimationFrame(() => {
        track.classList.remove('is-dragging');
        isDragging = false;
      });
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('lostpointercapture', end);

    track.addEventListener('click', (e) => {
      if (maxMoved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    track.addEventListener('dragstart', (e) => e.preventDefault());
  });

  document.querySelectorAll('[data-qty-change]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.product__qty').querySelector('.product__qty-input');
      const max = parseInt(input.max, 10) || Infinity;
      const current = parseInt(input.value, 10) || 1;
      input.value = Math.min(max, Math.max(1, current + parseInt(btn.dataset.qtyChange, 10)));
    });
  });

  document.querySelectorAll('.product__qty-input').forEach(input => {
    input.addEventListener('change', () => {
      const max = parseInt(input.max, 10) || Infinity;
      const value = parseInt(input.value, 10) || 1;
      input.value = Math.min(max, Math.max(1, value));
    });
  });

  // Sticky bar: visible only after the main buy button has scrolled up
  // out of view.
  (() => {
    const stickyBar = document.querySelector('[data-sticky-bar]');
    if (!stickyBar || !('IntersectionObserver' in window)) return;
    const mainBtn = document.querySelector('.product-form:not(.product__sticky-form) .product__btn');
    if (!mainBtn) return;

    // Keep the bar in the top layer for good so it paints above the chat
    // widget; showing/hiding stays the .is-visible toggle below.
    if (typeof stickyBar.showPopover === 'function') {
      try {
        if (!stickyBar.matches(':popover-open')) stickyBar.showPopover();
      } catch (error) {
        /* detached or already shown — the class toggle still works */
      }
    }

    const io = new IntersectionObserver((entries) => {
      const entry = entries[0];
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    });
    io.observe(mainBtn);
  })();

  if (!window.__productCartHandlerAttached) {
    window.__productCartHandlerAttached = true;

    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('.product-form')) return;

      e.preventDefault();

      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
        });
        if (!addRes.ok) throw new Error('cart/add status ' + addRes.status);

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } catch (err) {
        console.error('Failed to add to cart:', err);
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-form"] && !Shopify.designMode) return;
  try {
    
/* Same flow as the production returns form: validate the receipt files
   if any were chosen (count, size per file, total size), upload each one straight to Vercel
   Blob through the @vercel/blob client (loaded on demand from esm.sh, the
   token comes from the upload endpoint), then POST the form fields plus
   the upload references as JSON. The fields are swapped for the success
   or error message afterwards. */
class ReturnForm extends HTMLElement {
  connectedCallback() {
    var form = this.querySelector('[data-return-form]');
    if (!form || this.dataset.bound) return;
    this.dataset.bound = 'true';

    var self = this;
    var fields = this.querySelector('[data-fields]');
    var success = this.querySelector('[data-success]');
    var failure = this.querySelector('[data-error]');
    var fileInput = form.querySelector('input[type="file"]');
    var fileError = this.querySelector('[data-file-error]');
    var submit = form.querySelector('button[type="submit"]');

    var maxFiles = parseInt(this.dataset.maxFiles, 10) || 2;
    var maxFileBytes = (parseInt(this.dataset.maxFileMb, 10) || 50) * 1024 * 1024;
    var maxTotalBytes = (parseInt(this.dataset.maxTotalMb, 10) || 200) * 1024 * 1024;

    // Map extensions to MIME types so HEIC/HEIF (empty file.type in some
    // browsers) still match the content types the upload endpoint allows.
    var extTypes = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      webp: 'image/webp',
      heic: 'image/heic',
      heif: 'image/heif'
    };

    function showFileError(message) {
      fileError.textContent = message;
      fileError.hidden = false;
    }

    function clearFileError() {
      fileError.textContent = '';
      fileError.hidden = true;
    }

    function validateFiles() {
      var files = fileInput.files;
      if (!files || files.length === 0) return true;
      if (files.length > maxFiles) {
        showFileError(self.dataset.errorTooMany);
        return false;
      }
      var total = 0;
      for (var i = 0; i < files.length; i++) {
        if (files[i].size > maxFileBytes) {
          showFileError(self.dataset.errorTooLarge.replace('__FILENAME__', files[i].name));
          return false;
        }
        total += files[i].size;
      }
      if (total > maxTotalBytes) {
        showFileError(self.dataset.errorTotal);
        return false;
      }
      clearFileError();
      return true;
    }

    function guessContentType(file) {
      var type = (file.type || '').toLowerCase();
      for (var key in extTypes) {
        if (extTypes[key] === type) return type;
      }
      var ext = (file.name.split('.').pop() || '').toLowerCase();
      return extTypes[ext] || 'application/octet-stream';
    }

    function setLoading(on) {
      submit.classList.toggle('is-loading', on);
      submit.disabled = on;
    }

    function showResult(el) {
      fields.hidden = true;
      el.hidden = false;
      self.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    fileInput.addEventListener('change', function () {
      if (!validateFiles()) fileInput.value = '';
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!validateFiles()) return;

      var files = Array.prototype.slice.call(fileInput.files || []);
      setLoading(true);

      try {
        // Step 1: upload each file directly to Vercel Blob (bypasses the
        // 4.5 MB serverless request-body limit).
        var client = await import(self.dataset.blobClient);
        var datePrefix = new Date().toISOString().slice(0, 10);
        var uploads = [];
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          var contentType = guessContentType(file);
          var blob = await client.upload('returns/' + datePrefix + '/' + file.name, file, {
            access: 'private',
            handleUploadUrl: self.dataset.uploadEndpoint,
            contentType: contentType
          });
          uploads.push({
            url: blob.url,
            pathname: blob.pathname,
            contentType: contentType,
            size: file.size
          });
        }

        // Step 2: submit form fields + upload references as JSON.
        var payload = {};
        new FormData(form).forEach(function (value, key) {
          if (key !== 'receipt_copy') payload[key] = value;
        });
        payload.uploads = uploads;

        var response = await fetch(self.dataset.submitEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Request failed with status ' + response.status);
        await response.json().catch(function () { return {}; });

        setLoading(false);
        showResult(success);
      } catch (err) {
        console.error(err);
        setLoading(false);
        showResult(failure);
      }
    });
  }
}

if (!customElements.get('return-form')) {
  customElements.define('return-form', ReturnForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-serial-modal-open]');
  if (trigger) {
    const dialog = document.getElementById(trigger.getAttribute('data-serial-modal-open'));
    if (dialog) dialog.showModal();
    return;
  }

  const closeBtn = event.target.closest('[data-serial-modal-close]');
  if (closeBtn) {
    closeBtn.closest('dialog').close();
    return;
  }

  const dialog = event.target.closest('dialog.warranty-form__modal');
  if (dialog && dialog.open) {
    const rect = dialog.getBoundingClientRect();
    const outside =
      event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom;
    if (outside) dialog.close();
  }
});

document.querySelectorAll('.warranty-form__phone').forEach((wrapper) => {
  const input = wrapper.querySelector('input[type="tel"]');
  const prefix = (wrapper.dataset.prefix || '').trim();
  if (!input || !prefix) return;

  const stripPrefix = () => {
    const value = input.value.trimStart();
    const variants = [prefix, prefix.replace('+', '00')];
    for (const variant of variants) {
      if (value.startsWith(variant)) {
        input.value = value.slice(variant.length).trim();
        return;
      }
    }
  };

  input.addEventListener('input', stripPrefix);
  input.addEventListener('change', stripPrefix);
  input.addEventListener('blur', stripPrefix);
});

  } catch(e) { console.error(e); }
})();
})();
